/**
 * @generated SignedSource<<944573d59d2432de26b5333255d4273d>>
 * @relayHash 411aa56f960d21732fdea57d6645aefa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a480d9b1888fbb308b36f8f29f5b4576f84e4817c537652251e266c7ab98d45d

import type { ConcreteRequest } from 'relay-runtime';
export type useGetTeamAndSubanchorGetPersonalSpaceKeyQuery$variables = Record<PropertyKey, never>;
export type useGetTeamAndSubanchorGetPersonalSpaceKeyQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly hasPersonalSpace: boolean | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly team: string | null | undefined;
  } | null | undefined;
};
export type useGetTeamAndSubanchorGetPersonalSpaceKeyQuery = {
  response: useGetTeamAndSubanchorGetPersonalSpaceKeyQuery$data;
  variables: useGetTeamAndSubanchorGetPersonalSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "team"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPersonalSpace"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "411aa56f960d21732fdea57d6645aefa",
    "id": "a480d9b1888fbb308b36f8f29f5b4576f84e4817c537652251e266c7ab98d45d",
    "metadata": {},
    "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
    "operationKind": "query",
    "text": "query useGetTeamAndSubanchorGetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
  }
};
})();

(node as any).hash = "d084357d5b8c80b2a717087a9d5973e6";

export default node;
